import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { IoIosEye } from 'react-icons/io'

const ApprovalDocs = ({title,file_name,setPreview}) => {
    return (
        <>
        {file_name&&
            <div style={{display:"inline-block", height:'50px', margin: '5px'}}>
                <a href="javascript:void(0)" className="navigation_button" onClick={()=>setPreview(file_name)} style={{textDecoration: 'none'}}>{title} <IoIosEye></IoIosEye></a>
            </div>
        }
        
        </>
    )
}

export default ApprovalDocs